<template>
  <header class="app-header bg-green-50 p-4 rounded-lg mb-4 flex items-center justify-between">
    <h1 class="text-xl font-bold text-green-700">
      <slot>App Header</slot>
    </h1>
    <slot name="actions" />
  </header>
</template>
<script setup lang="ts">
// Basic AppHeader stub
</script>
<style scoped>
.app-header {
  border-bottom: 1px solid #e5e7eb;
}
</style>
